import { DOT } from "./frfr-string-consts";


/*
FrFr FRIENDLY FRAMEWORK
frfr-bomlevel-utils
Version ID: 1a 2023-09-07r1
by 
// Please describe here if you customized this file
*/


// BOMLEVEL UTILS, GRAPHLEVEL UTISLS, TRAVERSING...

/*
DOKUMENTACIJA:

---
is bomlevel root se proverava sa graphlevel

---REDOSLED traversinga kroz BOM je sledeci
1) next children bomlevel
2) ako nema onda next sibling bomlevel
3) ako nema onda next sibling of parent bomlevel (_get_next_parentsibling_bomlevel)
4) ako nema dalje nastavlja sa _get_next_parentsibling_bomlevel sve dok ne dodje do top levela

*/


//
export const _is_bomlevel_valid = (bomlevel) => {
  let test = true;
  if (typeof bomlevel === 'string' && bomlevel !== '') {
    const arr = bomlevel.split(DOT);
    arr.forEach((segment) => {
      if (typeof segment === 'string' && segment !== '') {
        const n = Number.parseFloat(segment);
        if (!isNaN(n) && Number.isInteger(n) && n > 0) {
          // valid
        } else {
          test = false; // invalid segment is not an integer > 0
        }
      } else {
        test = false; // invalid segment is not a string
      }
    });
  } else {
    test = false; // invalid bomlevel is not a string or is empty string
  }
  return test;
};
export const _is_graphlevel_valid = (graphlevel) => {
  if (Number.isInteger(graphlevel) && graphlevel > 0) {
    return true;
  }
  return false; // invalid graphlevel
};


//
const _bomlevel_return_helper = (bomlevel) => {
  if (_is_bomlevel_valid(bomlevel)) {
    return bomlevel;
  }
  return false;
};


//
export const _detect_graphlevel = (bomlevel) => {
  // detect graphlevel by bomlevel
  if (_is_bomlevel_valid(bomlevel)) {
    const _bomlevel = bomlevel.toString();
    const countOfDots = _bomlevel.split(DOT).length - 1;
    const graphlevel = countOfDots + 1;
    return graphlevel;
  }
  return false; // invalid bomlevel
};
export const _detect_bomlevel_integer = (bomlevel, graphlevel) => {
  // example: "3.7.4" and grapjlevel 2 will return 7
  if (_is_bomlevel_valid(bomlevel) && _is_graphlevel_valid(graphlevel)) {
    const arr = bomlevel.split(DOT);
    const ownBomLevelInteger = Number.parseInt(arr[graphlevel - 1]);
    return ownBomLevelInteger;
  }
  return false;  // invalid bomlevel or grašhlevel
};
export const _detect_own_bomlevel_integer = (bomlevel) => {
  // example: "3.7.4" will return 4
  if (_is_bomlevel_valid(bomlevel)) {
    const arr = bomlevel.split(DOT);
    const ownBomLevelInteger = Number.parseInt(arr[arr.length - 1]);
    if (Number.isInteger(ownBomLevelInteger) && ownBomLevelInteger > 0) {
      return ownBomLevelInteger;
    }
  }
  return false; // invalid bomlevel
};
export const _detect_parent_bomlevel = (bomlevel) => {
  // console.log('_detect_parent_bomlevel(bomlevel) ', bomlevel);
  if (_is_bomlevel_valid(bomlevel)) {
    const arr = bomlevel.split(DOT);
    // example: if bomlevel "1" arr will be ["1"] (single item)
    // example: if bomlevel "" arr will be [""] (single item empty string)
    // console.log(arr);
    // console.log(arr.length - 2);
    const parentBomLevelArr = arr.slice(0, (arr.length - 1));
    // example: if arr ["1"] parentBomLevelArr will be [] (empty array)
    // example: if arr [""] parentBomLevelArr will be [] (empty array)
    // console.log(parentBomLevelArr);
    const parent_bomlevel = parentBomLevelArr.join(DOT);
    // example: if parentBomLevelArr [] parent_bomlevel will be "" (empty string)
    // return parent_bomlevel;
    // example: if bomlevel "1" parent_bomlevel will be "" (empty string)
    // example: if bomlevel "" parent_bomlevel will be "" (empty string)
    return _bomlevel_return_helper(parent_bomlevel);
  }
  return false; // invalid bomlevel
};

export const _detect_bomlevel_on_graphlevel = (bomlevel, graphlevel) => {
  // TODO
  // example: "3.4.8.7" and graphlevel 2 will return "3.4"
  // example: "3.4.8.7" and graphlevel 4 will return "3.4.8.7"
  if (_is_bomlevel_valid(bomlevel) && _is_graphlevel_valid(graphlevel)) {
    let _x_bomlevel = '';
    const arr = bomlevel.split(DOT);
    if (arr.length > graphlevel || arr.length === graphlevel) {
      arr.forEach((integer, index) => {
        if ((index + 1) <= graphlevel) {
          if ((index + 1) === 1) {
            _x_bomlevel += integer;
          } else {
            _x_bomlevel += DOT + integer;
          }
        }
      });
      return _bomlevel_return_helper(_x_bomlevel.toString());
    }
  }
  return false; // invalid bomlevel or graphlevel
};


//
export const _is_bomlevel1_ancestor_of_bomlevel2 = (ancestor_bomlevel, bomlevel) => {
  // Da li je bomlevel1 hijerarhijski iznad bomlevel2, odnosno da li je bomlevel2 hijerarhijski ispod bomlevel1
  // example: "3.4.8.7" and "3.4.8.7" will return false
  // example: "3.4" and "3.4.8.7" will return true
  // example: "2.1.5" and "2.1" will return false
  // you can also get is bomlevel descendant of bomlevel if you seap arguments
  // example: "3.4.8.7" and "3.4" will return false
  // example: "2.1" and "2.1.5" will return true
  if (_is_bomlevel_valid(ancestor_bomlevel) && _is_bomlevel_valid(bomlevel)) {
    const ancestor_graphlevel = _detect_graphlevel(ancestor_bomlevel);
    const graphlevel = _detect_graphlevel(bomlevel);
    let test = true;
    if (ancestor_graphlevel < graphlevel) {
      const arr1 = ancestor_bomlevel.split(DOT);
      const arr2 = bomlevel.split(DOT);
      arr1.forEach((integer1, index) => {
        const integer2 = arr2[index];
        if (integer1 !== integer2) {
          test = false;
        }
      });
      return test;
    }
  }
  return false;  // invalid bomlevel or graphlevel
};

//
export const _get_next_children_bomlevel = (bomlevel) => {
  if (_is_bomlevel_valid(bomlevel)) {
    const nextChildrenBomLevel = bomlevel + DOT + 1;
    return nextChildrenBomLevel;
  }
  return false; // invalid bomlevel
};
export const _get_next_sibling_bomlevel = (bomlevel) => {
  // console.log('_get_next_sibling_bomlevel(bomlevel) ', bomlevel);
  const integer = _detect_own_bomlevel_integer(bomlevel); // bomlevel will also be validated
  if (integer !== false) {
    const graphlevel = _detect_graphlevel(bomlevel);
    let nextBomLevel;
    if (graphlevel > 1) {
      const parent_bomlevel = _detect_parent_bomlevel(bomlevel);
      nextBomLevel = parent_bomlevel + DOT + (integer + 1);
    } else {
      // root graphlevel 1
      nextBomLevel = (integer + 1).toString();
    }
    // console.log(nextBomLevel);
    return nextBomLevel;
  } else {
    return false; // nesto nije u redu sa integerom (takidje moguce invalid bomlevel)
  }
};
export const _get_next_parentsibling_bomlevel = (bomlevel) => {
  // next sibling of parent
  // console.log('_get_next_parentsibling_bomlevel(bomlevel) ', bomlevel);
  if (_is_bomlevel_valid(bomlevel)) {
    const graphlevel = _detect_graphlevel(bomlevel);
    let nextParentSiblingLevel;
    if (graphlevel > 1) {
      const parent_bomlevel = _detect_parent_bomlevel(bomlevel);
      nextParentSiblingLevel = _get_next_sibling_bomlevel(parent_bomlevel);
    } else {
      // ??? ne sme da se dogodi ova kombinacija
      nextParentSiblingLevel = false;
    }
    // console.log(nextParentSiblingLevel);
    return nextParentSiblingLevel;
  }
  return false; // invalid bomlevel
};


//
export const _is_next_graphlevel_valid = (graphlevel, next_graphlevel) => {
  if (_is_graphlevel_valid(graphlevel) && _is_graphlevel_valid(next_graphlevel)) {
    if (next_graphlevel === graphlevel) {
      return true; // CASE sibling graphlevel - potential next sibling bomlevel
    } else if (next_graphlevel > graphlevel) {
      if ((next_graphlevel - graphlevel) === 1) {
        return true; // CASE children graphlevel - potential next children bomlevel
      } else {
        return false; // next_graphlevel is not allowed
      }
    } else if (next_graphlevel < graphlevel) {
      return true; // CASE PARENT SIBLING or ANCESTOR SIBLING
    }
    // else - just in case
    return false; // next_graphlevel is not allowed
  } else {
    return false; // invalid graphlevel
  }
};


////
export const _get_next_bomlevel_on_graphlevel = (bomlevel, next_graphlevel) => {
  // TODO
  // 
  // next allowed bomlevel on graplevel
  // example: posle "1.2.3.4" dozvoljeni su "2" ili "1.3" ili "1.2.4" ili "1.2.3.5" ili "1.2.3.4.1"
  if (_is_graphlevel_valid(next_graphlevel)) {
    const current_graphlevel = _detect_graphlevel(bomlevel); // bomlevel will also be validated
    if (current_graphlevel !== false && _is_next_graphlevel_valid(current_graphlevel, next_graphlevel)) {
      if ((next_graphlevel - current_graphlevel) === 1) {
        // CASE next children
        return _get_next_children_bomlevel(bomlevel);
      } else if ((next_graphlevel - current_graphlevel) < 1) {
        // CASE next sibling or parent sibling or ancestor sibling
        const arr = bomlevel.split(DOT);
        let next_bomlevel = '';
        arr.forEach((int, index) => {
          let integer = int;
          if ((index + 1) === next_graphlevel) {
            integer = (Number.parseInt(int) + 1).toString();
          }
          if ((index + 1) <= next_graphlevel) {
            if ((index + 1) === 1) {
              next_bomlevel += integer;
            } else {
              next_bomlevel += DOT + integer;
            }
          }
        });
        return next_bomlevel.toString();
      }
      // else
      // just in case - already checked with _is_next_graphlevel_valid
      return false; // next_graphlevel is not allowed
    } else {
      return false; // next_graphlevel is not allowed or invalid bomlevel
    }
  }
  return false; // invalid graphlevel
};



// MERGE AND DETACH
export const _merge_bomlevel_as_child = (master_bomlevel, slave_bomlevel) => {
  //
  if (_is_bomlevel_valid(master_bomlevel) && _is_bomlevel_valid(slave_bomlevel)) {
    if (master_bomlevel === '') {
      // ***this case is impossible when we use valid bomlevels
      // example: "" merged with "3.6" will become "3.6"
      const merged_bomlevel = slave_bomlevel;
      return merged_bomlevel.toString();
    } else {
      // example: "2.1.5" merged with "3.6" will become "2.1.5.3.6"
      const merged_bomlevel = master_bomlevel + DOT + slave_bomlevel;
      return merged_bomlevel.toString();
    }
  }
  return false;
};
export const _merge_bomlevel_as_sibling = (master_bomlevel, slave_bomlevel) => {
  //
  // example: "2.1.5" merged with "3.6" will become "2.1.8.6"
  // example: "4" merged with "3.7" will become "7.6"
  if (_is_bomlevel_valid(master_bomlevel) && _is_bomlevel_valid(slave_bomlevel)) {
    const master_bomlevel_last_integer = _detect_own_bomlevel_integer(master_bomlevel);
    const slave_bomlevel_first_integer = _detect_bomlevel_integer(slave_bomlevel, 1);
    const merged_integer = master_bomlevel_last_integer + slave_bomlevel_first_integer;
    const master_graphlevel = _detect_graphlevel(master_bomlevel);
    let merged_bomlevel = '';
    if (master_graphlevel > 1) {
      const parent_bomlevel = _detect_parent_bomlevel(master_bomlevel);
      merged_bomlevel = parent_bomlevel + DOT + merged_integer;
    } else {
      merged_bomlevel = merged_integer;
    }
    const arr = slave_bomlevel.split(DOT);
    arr.forEach((integer, index) => {
      // console.log('slave_bomlevel', integer, index);
      if (index === 0) {
        // already merged
      } else {
        merged_bomlevel += DOT + integer;
      }
    });
    return merged_bomlevel.toString();
  } else {
    console.log('_merge_bomlevel_as_sibling ERROR: master_bomlevel and slave_bomlevel must be valid bomlevel', master_bomlevel, slave_bomlevel);
    return false;
  }
};
export const _merge_bomlevel_on_graphlevel = (master_bomlevel, slave_bomlevel, graphlevel) => {
  //
  // example: "2.1.5" merged with "3.6" on graphlelvel 1 will become "5.6"
  // example: "2.1.5" merged with "3.6" on graphlelvel 2 will become "2.4.6"
  // example: "2.1.5" merged with "3.6" on graphlelvel 3 will become "2.1.8.6"
  // example: "2.1.5" merged with "3.6" on graphlelvel 4 will become "2.1.5.3.6"
  const master_graphlevel = _detect_graphlevel(master_bomlevel);
  // const slave_graphlevel = _detect_graphlevel(slave_bomlevel);
  if (_is_next_graphlevel_valid(master_graphlevel, graphlevel)) {
    // valid next children graphlevel
    if (graphlevel > master_graphlevel) {
      return _merge_bomlevel_as_child(master_bomlevel, slave_bomlevel);
    } else {
      // merge as sibling
      const _master_bomlevel_shortened = _detect_bomlevel_on_graphlevel(master_bomlevel, graphlevel);
      return _merge_bomlevel_as_sibling(_master_bomlevel_shortened, slave_bomlevel);
    }
  }
  return false; // invalid graphlevel
};
export const _detach_bomlevel = (bomlevel, graphlevel) => {
  // detach, segregate...
  // INFO: _detach_virbom_where_bomlevel odvaja
  // odvaja (uzima) samo jednu granu 
  // example: "2.4.6.8" on graphlevel 1 will become "1.4.6.8"
  // example: "2.4.6.8" on graphlevel 2 will become "1.6.8"
  // example: "2.4.6.8" on graphlevel 3 will become "1.8"
  // example: "2.4.6.8" on graphlevel 4 will become "1"
  if (_is_graphlevel_valid(graphlevel)) {
    const arr = bomlevel.split(DOT);
    let detached_bomlevel = '';
    arr.forEach((integer, index) => {
      if ((index + 1) < graphlevel) {
        // skip
      } else if ((index + 1) === graphlevel) {
        detached_bomlevel += "1"; // initial_bomlevel ROOT
      } else {
        detached_bomlevel += DOT + integer;
      }
    });
    return detached_bomlevel.toString();
  }
  return false;
};




// STEPPER MOTOR
export const _get_next_bom_row_smart = (last_bomlevel, _cb_get_bom_row) => {
  // STEPPER MOTOR
  // console.log('*** _get_next_bom_row_smart(last_bomlevel, _cb_get_bom_row) ', last_bomlevel);
  let bom_row = false;
  let bomlevel = false;

  /*
  primer scenario jedne iteracije
  ako se petlja nalazi na nivou 1.2.4.3
  moze da ide u pravcu next children da pokusa 1.2.4.3.1
  ako ne uspe onda u pravcu next sibling pokusa 1.2.4.4
  ako ne uspe onda u pravcu next parent sibling pokusa 1.2.5
  ukoliko i to ne uspe ponavljajuci opet u pravcu next paren sibling pokusa 1.3
  i tako dalje isto pokusa 2
  to znaci da je dosla do graph level 1 (root level) i nema dalji parent i tada je istrazivanje potpuno zavrseno
  
  direction: 
  1) self, 
  2) to children, 
  3) to next sibling, 
  4) to next parent sibling
  takodje kada posmatramo da ta petlja i simulira pozivanja vise petlji, onda mozemo da u tome uocavamo i da su tu i pocetak (pre nested petlje), sredina (nested petlja) i kraj (posle nested petlje)...
  
  */

  // START
  let exit = false;
  if (last_bomlevel === null) {
    // inicijalni poziv
    //
    // ----- direction 1) SELF
    // koristi se samo pri inicijalnom pozivu steperu
    console.log('direction 1 SELF');
    // INITIAL ITERATION starting frim bomlevel "1"
    const initial_bomlevel = "1"; // initial bomlevel is "1"
    bom_row = _cb_get_bom_row(initial_bomlevel);
    console.log('initial bom_row', bom_row);
    if (bom_row !== false) {
      bomlevel = initial_bomlevel;
      exit = true;
    } else {
      // trazeni inicijalni element sam ne postoji
      // to znaci da je traversing zavrsen i ne vraca ni jedan elemenat za dalji prikaz
      // bomlevel ostaje po defaultu false
      bom_row = false; // will return bom_row = false
      exit = true;
    }
  } else {
    // ukoliko nije inicijalni poziv prelazi na children element
    //
    // ----- direction 2) TO CHILDREN
    // next children element
    // console.log('direction 2 TO CHILDREN');
    bomlevel = _get_next_children_bomlevel(last_bomlevel);
    bom_row = _cb_get_bom_row(bomlevel);
    if (bom_row !== false) {
      exit = true;
    } else {
      // ako ne postoji children prelazi na next sibling
      //
      // ----- direction 3) TO NEXT SIBLING
      // next sibling element
      // console.log('direction 3 TO NEXT SIBLING');
      bomlevel = _get_next_sibling_bomlevel(last_bomlevel);
      bom_row = _cb_get_bom_row(bomlevel);
      if (bom_row !== false) {
        exit = true;
      } else {
        // ako ne postoji next sibling onda prelazi na sibling od parenta
        //
        // ----- direction 4) TO PARENT SIBLING
        // sibling of next parent element
        let bomlevel_direction_4 = last_bomlevel;
        while (exit === false) {
          // console.log('direction 4 TO PARENT SIBLING');
          const graphlevel = _detect_graphlevel(bomlevel_direction_4);
          if (graphlevel > 1) {
            bomlevel = _get_next_parentsibling_bomlevel(bomlevel_direction_4);
            bom_row = _cb_get_bom_row(bomlevel);
            if (bom_row !== false) {
              exit = true;
            } else {
              // ukoliko na parent nivou nema sibling
              // ide se na rekurziju pa sledeci parent sibling
              // while loop will make one more iteration
              bomlevel_direction_4 = bomlevel;
            }
          } else {
            // nema vise parent levela jer smo na graphlevel 1 tj. root levelu
            bom_row = false;
            exit = true;
          }
          // REPEAT
        } // end of while direction 4
      }
    }
  }
  // END
  //
  // console.log('[bomlevel, bom_row] - bomlevel: ', bomlevel);
  return [bomlevel, bom_row];
}; // end of _get_next_bom_row_smart


export const _is_next_bomlevel_valid = (bomlevel, next_bomlevel) => {
  let valid = false;
  if (_is_bomlevel_valid(bomlevel) && _is_bomlevel_valid(next_bomlevel)) {
    // ----- direction 2) TO CHILDREN
    const test_bomlevel_children = _get_next_children_bomlevel(bomlevel);
    // console.log('dir 1', bomlevel, test_bomlevel_children);
    if (test_bomlevel_children === next_bomlevel) {
      valid = true;
      return valid;
    } else {
      // ----- direction 3) TO NEXT SIBLING
      const test_bomlevel_sibling = _get_next_sibling_bomlevel(bomlevel);
      if (test_bomlevel_sibling === next_bomlevel) {
        valid = true;
        return valid;
      } else {
        // ----- direction 4) TO PARENT SIBLING
        let bomlevel_direction_4 = bomlevel;
        let exit = false;
        while (exit === false) {
          const graphlevel = _detect_graphlevel(bomlevel_direction_4);
          if (graphlevel > 1) {
            let _test_4_bomlevel = _get_next_parentsibling_bomlevel(bomlevel_direction_4);
            if (_test_4_bomlevel === next_bomlevel) {
              valid = true;
              exit = true;
            } else {
              // ukoliko na parent nivou nema sibling
              // ide se na rekurziju pa sledeci parent sibling
              // while loop will make one more iteration
              bomlevel_direction_4 = _test_4_bomlevel;
            }
          } else {
            // nema vise parent levela jer smo na graphlevel 1 tj. root levelu
            exit = true;
          }
        } // end of while
        return valid;
      }
    }
  }
  return false;
};

